import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useContext } from 'react';
import { View } from 'react-native';
import ComparePlanCard from './components/compare-plan-card/ComparePlanCard';
import { getComparisonViewCardWidgetStyles } from './ComparisonViewCardWidgetStyles';
import { getTestId, CardTitle, Collapsible, StateConfigContext } from '@airtel/air-design-system';
import { ComparisonTableWidgetV2Component } from './v2/ComparisonTableWidgetV2Component';
export var ComparisonViewCardWidgetComponent = props => {
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _props$removeSelected = props.removeSelectedValueFromDropdown,
    removeSelectedValueFromDropdown = _props$removeSelected === void 0 ? false : _props$removeSelected,
    comparisonViewCardList = props.comparisonViewCardList,
    style = props.style,
    testID = props.testID,
    _props$showEmptyInfoT = props.showEmptyInfoTagContainer,
    showEmptyInfoTagContainer = _props$showEmptyInfoT === void 0 ? false : _props$showEmptyInfoT,
    _props$isTableView = props.isTableView,
    isTableView = _props$isTableView === void 0 ? false : _props$isTableView,
    _props$showSpaceBetwe = props.showSpaceBetweenCards,
    showSpaceBetweenCards = _props$showSpaceBetwe === void 0 ? isTableView ? false : true : _props$showSpaceBetwe,
    _props$isLastVertical = props.isLastVerticalItem,
    isLastVerticalItem = _props$isLastVertical === void 0 ? true : _props$isLastVertical,
    isCollapsible = props.isCollapsible,
    disableToggle = props.disableToggle,
    initialOpen = props.initialOpen,
    _props$showIcon = props.showIcon,
    showIcon = _props$showIcon === void 0 ? true : _props$showIcon,
    collapsibleTitle = props.collapsibleTitle,
    collapsibleSubTitle = props.collapsibleSubTitle,
    comparisonViewList = props.comparisonViewList,
    selectedPlanValueList = props.selectedPlanValueList,
    _props$index = props.index,
    verticalListItemIndex = _props$index === void 0 ? 0 : _props$index,
    _props$comparisonWidg = props.comparisonWidgetVersion,
    comparisonWidgetVersion = _props$comparisonWidg === void 0 ? '1' : _props$comparisonWidg,
    onSelectedPlanValueListChanged = props.onSelectedPlanValueListChanged,
    onUserAction = props.onUserAction;
  var comparisonViewCardWidgetStyles = getComparisonViewCardWidgetStyles(comparisonViewCardList === null || comparisonViewCardList === void 0 ? void 0 : comparisonViewCardList.length);
  var _useState = useState(initialOpen),
    isExpanded = _useState[0],
    setIsExpanded = _useState[1];
  var _useState2 = useState(selectedPlanValueList !== null && selectedPlanValueList !== void 0 ? selectedPlanValueList : []),
    selectedPlanValue = _useState2[0],
    setSelectedPlanValue = _useState2[1];
  var _useState3 = useState(removeSelectedValueFromDropdown ? Object.assign({}, selectedPlanValueList) : {}),
    selectedDropdownList = _useState3[0],
    setSelectedDropdownList = _useState3[1];
  var onCollapsibleToggleHandler = state => {
    setIsExpanded(state);
  };
  var onPlanSelected = (planValue, index, value) => {
    removeSelectedValueFromDropdown && setSelectedDropdownList(prev => Object.assign(Object.assign({}, prev), {
      [index]: value
    }));
    onSelectedPlanValueListChanged === null || onSelectedPlanValueListChanged === void 0 ? void 0 : onSelectedPlanValueListChanged([...planValue]);
  };
  var onSelectedPlanValueListChangedHandler = planValue => {
    setSelectedPlanValue([...planValue]);
  };
  if (comparisonWidgetVersion == '2') {
    return _jsx(ComparisonTableWidgetV2Component, Object.assign({}, props));
  }
  if (comparisonViewList) {
    return _jsx(_Fragment, {
      children: comparisonViewList === null || comparisonViewList === void 0 ? void 0 : comparisonViewList.map((comparisonViewListProps, index) => _jsx(ComparisonViewCardWidgetComponent, Object.assign({
        index: index,
        isTableView: isTableView,
        isLastVerticalItem: index == comparisonViewList.length - 1
      }, comparisonViewListProps, {
        comparisonViewList: null,
        selectedPlanValueList: selectedPlanValue,
        onSelectedPlanValueListChanged: onSelectedPlanValueListChangedHandler,
        onUserAction: onUserAction,
        showEmptyInfoTagContainer: showEmptyInfoTagContainer
      }, getTestId(testID, 'ComparisonViewCardWidget')), index))
    });
  }
  if (isCollapsible) {
    return _jsx(Collapsible, Object.assign({
      childNoVerticalPadding: true,
      childNoHorizontalPadding: true,
      titleComponent: collapsibleTitle && _jsx(CardTitle, Object.assign({
        title: collapsibleTitle,
        subTitle: collapsibleSubTitle,
        style: comparisonViewCardWidgetStyles.titleContainer
      }, getTestId(testID, 'cardTitle'))),
      showIcon: showIcon,
      disabled: disableToggle,
      initialOpen: initialOpen,
      onToggleHandler: onCollapsibleToggleHandler,
      style: [isTableView && Object.assign({}, comparisonViewCardWidgetStyles.collapsibleContainer), isTableView && !isExpanded ? comparisonViewCardWidgetStyles === null || comparisonViewCardWidgetStyles === void 0 ? void 0 : comparisonViewCardWidgetStyles.collapsibleTitleLastItem : {}, style]
    }, getTestId(testID), {
      children: _jsx(View, Object.assign({
        style: comparisonViewCardWidgetStyles.compareWrapper
      }, {
        children: comparisonViewCardList === null || comparisonViewCardList === void 0 ? void 0 : comparisonViewCardList.map((comparisonViewCardProps, index) => _jsx(ComparePlanCard, Object.assign({
          index: index,
          style: showSpaceBetweenCards && index < (comparisonViewCardList === null || comparisonViewCardList === void 0 ? void 0 : comparisonViewCardList.length) - 1 && comparisonViewCardWidgetStyles.sectionRightMargin,
          onPlanSelected: onPlanSelected,
          isTableView: isTableView,
          isFirstVerticalItem: verticalListItemIndex == 0,
          isLastVerticalItem: isLastVerticalItem,
          isLastHorizontalItem: index == comparisonViewCardList.length - 1,
          onUserAction: onUserAction
        }, comparisonViewCardProps, {
          selectedPlanValue: (selectedPlanValueList === null || selectedPlanValueList === void 0 ? void 0 : selectedPlanValueList.length) > 0 ? selectedPlanValueList : comparisonViewCardProps === null || comparisonViewCardProps === void 0 ? void 0 : comparisonViewCardProps.selectedPlanValue
        }, getTestId(testID + 'collapsilbe_comparePlanCard', index === null || index === void 0 ? void 0 : index.toString())), index))
      }))
    }));
  }
  return _jsx(View, Object.assign({}, getTestId(testID), {
    style: [comparisonViewCardWidgetStyles.compareWrapper, style]
  }, {
    children: comparisonViewCardList === null || comparisonViewCardList === void 0 ? void 0 : comparisonViewCardList.map((comparisonViewCardProps, index) => _jsx(ComparePlanCard, Object.assign({
      selectedDropdownList: selectedDropdownList,
      showEmptyInfoTagContainer: showEmptyInfoTagContainer,
      index: index,
      style: showSpaceBetweenCards && index < (comparisonViewCardList === null || comparisonViewCardList === void 0 ? void 0 : comparisonViewCardList.length) - 1 && comparisonViewCardWidgetStyles.sectionRightMargin,
      onPlanSelected: onPlanSelected,
      isTableView: isTableView,
      isFirstVerticalItem: verticalListItemIndex == 0,
      isLastVerticalItem: isLastVerticalItem,
      isLastHorizontalItem: index == comparisonViewCardList.length - 1,
      onUserAction: onUserAction
    }, comparisonViewCardProps, {
      selectedPlanValue: (selectedPlanValueList === null || selectedPlanValueList === void 0 ? void 0 : selectedPlanValueList.length) > 0 ? selectedPlanValueList : comparisonViewCardProps === null || comparisonViewCardProps === void 0 ? void 0 : comparisonViewCardProps.selectedPlanValue,
      theme: theme
    }, getTestId(testID + '_comparePlanCard', index === null || index === void 0 ? void 0 : index.toString())), index))
  }));
};
ComparisonViewCardWidgetComponent.genericRendererKey = 'AirComparisonViewCardWidget';